module.exports = __webpack_public_path__ + "img/PM_A04_front_en.e4525815.png";